import { useEffect, useState } from "react";

/**
 * WhatsAppFAB — global floating action button (bottom-right) for
 * "Talk to Expert on WhatsApp" / "File My ITR on WhatsApp".
 */
const WA_NUMBER = "919711162342";
const WA_MESSAGE = "Hi TaxSetu AI, I need to file my ITR. Please help.";
const WA_HREF = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGE)}`;

export default function WhatsAppFAB() {
  const [showLabel, setShowLabel] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setShowLabel(true), 2500);
    const t2 = setTimeout(() => setShowLabel(false), 9500);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  return (
    <a
      href={WA_HREF}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="File ITR on WhatsApp — Talk to TaxSetu Expert"
      data-testid="whatsapp-fab"
      className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-[70] group flex items-center gap-2"
    >
      <span
        className={`hidden sm:flex items-center gap-1 pl-3 pr-3 py-2 rounded-full bg-white text-emerald-700 text-[13px] font-semibold shadow-lg ring-1 ring-emerald-200 transition-all duration-500 ease-out origin-right ${
          showLabel ? "opacity-100 translate-x-0 scale-100" : "opacity-0 translate-x-4 scale-95 pointer-events-none"
        }`}
      >
        File ITR · WhatsApp
      </span>
      <span className="relative flex items-center justify-center">
        <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-60 animate-ping" />
        <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-xl shadow-emerald-500/40 ring-2 ring-white/70 group-hover:scale-110 transition-transform duration-200">
          <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 fill-white" aria-hidden="true">
            <path d="M19.11 17.41c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.27-.47-2.42-1.49-.89-.79-1.5-1.77-1.67-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49 0 1.47 1.07 2.89 1.22 3.09.15.2 2.1 3.2 5.08 4.49.71.31 1.27.5 1.7.64.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2.01-1.41.25-.69.25-1.28.17-1.41-.07-.13-.27-.2-.57-.35zM16.06 4.65c-6.27 0-11.36 5.09-11.36 11.36 0 2.01.53 3.95 1.53 5.66l-1.63 5.94 6.09-1.6c1.66.91 3.53 1.39 5.36 1.39 6.27 0 11.36-5.09 11.36-11.36 0-3.03-1.18-5.89-3.32-8.03-2.14-2.14-5-3.32-8.03-3.32zm0 20.83c-1.66 0-3.29-.45-4.71-1.29l-.34-.2-3.51.92.94-3.42-.22-.35a9.45 9.45 0 0 1-1.45-5.03c0-5.22 4.25-9.47 9.47-9.47 2.53 0 4.91.99 6.7 2.77 1.79 1.79 2.77 4.17 2.77 6.7 0 5.22-4.25 9.47-9.47 9.47z" />
          </svg>
        </span>
      </span>
    </a>
  );
}
